module.exports = __webpack_public_path__ + "media/1345ConferenceSpace.c5278541.mp4";